module.exports = __webpack_public_path__ + "static/media/Inventor Factory Design Utilities.6b9eea31.png";